module.exports = __webpack_public_path__ + "components/signup-page/static/snow-forecast_outside--header_logo-b9ce1a6318deb6d587f0ff4c683b42a5.webp";